export const auth = {
      title: 'Sign in to {{appName}}',
      subtitle: 'Access the admin console.',
      cardTitle: 'Sign in',
      cardSubtitle: 'Authenticate with Microsoft Entra ID to enter the system.',
      submit: 'Continue with Microsoft',
      demoSubmit: 'Enter Demo (read-only)',
      createdBy: 'Created by:',
      resumingButton: 'Completing sign-in...',
      resumingSession: 'We are completing your Microsoft Entra ID sign-in.',
      loginFailed: 'Microsoft Entra ID sign-in could not be completed.',
      accountSuspended: 'Your access is suspended. Contact an administrator to reactivate it.',
      provider: 'Provider',
      providerValue: 'Microsoft Entra ID',
      providerHint: 'Corporate access with single sign-on.',
      providerBadge: 'Secure SSO',
      accessTitle: 'Secure access',
      accessDescription: 'Use your corporate account to securely access the system.',
    } as const;
